import React, { FunctionComponent } from 'react'
import { Text, Flex } from '@afterpaytouch/core'
import { useCheckoutSizes } from '../../../../../utils/responsive'
import type { Money as MoneyType } from '@afterpay/types'
import { Money } from '../../../../../component'
import styles from './style.module.css'
import { useTranslation } from '../../../../../utils/convergence'

type SummaryItemProps = {
  id: string
  index?: number
  name: string
  amount: MoneyType
  downPaymentAmount?: MoneyType
  bold?: boolean
  testNameSpace?: string
}

export const SummaryItem: FunctionComponent<SummaryItemProps> = (props): JSX.Element => {
  const { id, index, name, amount, downPaymentAmount, bold = false, testNameSpace = '' } = props
  const { t } = useTranslation()
  const { textSize, smallTextSize } = useCheckoutSizes()

  return (
    <Flex direction='column' className={styles.container}>
      <Flex justifyContent='space-between' className={styles.item}>
        <Text size={textSize} bold={bold} testNameSpace={`summary-${testNameSpace}-${index ?? id}-name`}>
          {name}
        </Text>
        <Money value={amount} size={textSize} bold={bold} testNameSpace={`summary-${testNameSpace}-${index ?? id}-amount`} />
      </Flex>
      {downPaymentAmount && (
        <Flex justifyContent='space-between' className={styles.item}>
          <Text size={smallTextSize} color='Subtle' testNameSpace={`summary-pay-later-item-downpayment`}>
            {t('summary:downPayment')}
          </Text>
          <Text size={smallTextSize} color='Subtle'>
            -<Money value={downPaymentAmount} size={smallTextSize} color='Subtle' testNameSpace={`summary-pay-later-item-downpayment-amount`} />
          </Text>
        </Flex>
      )}
    </Flex>
  )
}
